var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.dashboardItems),function(item,idx){return _c('div',{key:idx,staticClass:"col-sm-6 col-md-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h3',[_vm._v(_vm._s(item.title))])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('p',{staticClass:"card-text"},[_c('ul',[(item.pending !== undefined)?_c('li',[_c('router-link',{attrs:{"to":item.link}},[_vm._v(_vm._s(item.pending)+" pendentes de Validação")])],1):_vm._e(),_vm._v(" "),(item.approved !== undefined)?_c('li',[_vm._v(_vm._s(item.approved)+" aprovados")]):_vm._e()])])])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/shared/dashboard.vue?vue&type=template&id=ab97db62&
// module id = null
// module chunks = 